// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,optimize_code_size,server_grpc1,long_type_number
// @generated from protobuf file "aware_proto/proto/ComputerEvents.proto" (package "aware", syntax proto3)
// tslint:disable
import { Empty } from "../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Event } from "./Event";
import { Person } from "./Person";
import { CityStateCountryInfo } from "./Location";
import { Place } from "./Location";
import { LocationMeasurement } from "./Location";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf enum aware.ComputerEvent.EventType
 */
export var ComputerEvent_EventType;
(function (ComputerEvent_EventType) {
    /**
     * @generated from protobuf enum value: Active = 0;
     */
    ComputerEvent_EventType[ComputerEvent_EventType["Active"] = 0] = "Active";
    /**
     * @generated from protobuf enum value: AFK = 1;
     */
    ComputerEvent_EventType[ComputerEvent_EventType["AFK"] = 1] = "AFK";
    /**
     * @generated from protobuf enum value: App_Change = 2;
     */
    ComputerEvent_EventType[ComputerEvent_EventType["App_Change"] = 2] = "App_Change";
})(ComputerEvent_EventType || (ComputerEvent_EventType = {}));
/**
 * @generated from protobuf enum aware.ComputerDeviceInfo.ComputerType
 */
export var ComputerDeviceInfo_ComputerType;
(function (ComputerDeviceInfo_ComputerType) {
    /**
     * @generated from protobuf enum value: Desktop = 0;
     */
    ComputerDeviceInfo_ComputerType[ComputerDeviceInfo_ComputerType["Desktop"] = 0] = "Desktop";
    /**
     * @generated from protobuf enum value: Laptop = 1;
     */
    ComputerDeviceInfo_ComputerType[ComputerDeviceInfo_ComputerType["Laptop"] = 1] = "Laptop";
})(ComputerDeviceInfo_ComputerType || (ComputerDeviceInfo_ComputerType = {}));
/**
 * An enum for identifying various chat services
 *
 * @generated from protobuf enum aware.ChatServiceType
 */
export var ChatServiceType;
(function (ChatServiceType) {
    /**
     * @generated from protobuf enum value: UnknownChatService = 0;
     */
    ChatServiceType[ChatServiceType["UnknownChatService"] = 0] = "UnknownChatService";
    /**
     * @generated from protobuf enum value: Discord = 1;
     */
    ChatServiceType[ChatServiceType["Discord"] = 1] = "Discord";
})(ChatServiceType || (ChatServiceType = {}));
/**
 * @generated from protobuf enum aware.DiscordPresenceStatus
 */
export var DiscordPresenceStatus;
(function (DiscordPresenceStatus) {
    /**
     * @generated from protobuf enum value: UnknownDiscordPresence = 0;
     */
    DiscordPresenceStatus[DiscordPresenceStatus["UnknownDiscordPresence"] = 0] = "UnknownDiscordPresence";
    /**
     * @generated from protobuf enum value: Online = 1;
     */
    DiscordPresenceStatus[DiscordPresenceStatus["Online"] = 1] = "Online";
    /**
     * @generated from protobuf enum value: Idle = 2;
     */
    DiscordPresenceStatus[DiscordPresenceStatus["Idle"] = 2] = "Idle";
    /**
     * @generated from protobuf enum value: Offline = 3;
     */
    DiscordPresenceStatus[DiscordPresenceStatus["Offline"] = 3] = "Offline";
    /**
     * @generated from protobuf enum value: Dnd = 4;
     */
    DiscordPresenceStatus[DiscordPresenceStatus["Dnd"] = 4] = "Dnd";
})(DiscordPresenceStatus || (DiscordPresenceStatus = {}));
// @generated message type with reflection information, may provide speed optimized methods
class ComputerEvent$Type extends MessageType {
    constructor() {
        super("aware.ComputerEvent", [
            { no: 1, name: "stamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "computer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "last_activity", kind: "message", T: () => Timestamp },
            { no: 5, name: "event_type", kind: "enum", T: () => ["aware.ComputerEvent.EventType", ComputerEvent_EventType] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ComputerEvent
 */
export const ComputerEvent = new ComputerEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ComputerSession$Type extends MessageType {
    constructor() {
        super("aware.ComputerSession", [
            { no: 2, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 3, name: "end_date", kind: "message", T: () => Timestamp },
            { no: 4, name: "events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ComputerEvent },
            { no: 5, name: "computer_info", kind: "message", T: () => ComputerDeviceInfo },
            { no: 6, name: "session_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ComputerSession
 */
export const ComputerSession = new ComputerSession$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ComputerDeviceInfo$Type extends MessageType {
    constructor() {
        super("aware.ComputerDeviceInfo", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "computer_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "computer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "computer_type", kind: "enum", T: () => ["aware.ComputerDeviceInfo.ComputerType", ComputerDeviceInfo_ComputerType] },
            { no: 5, name: "location", kind: "message", T: () => LocationMeasurement }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ComputerDeviceInfo
 */
export const ComputerDeviceInfo = new ComputerDeviceInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChatServiceAccountInfo$Type extends MessageType {
    constructor() {
        super("aware.ChatServiceAccountInfo", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "service_user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "service_user_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "chat_service_type", kind: "enum", T: () => ["aware.ChatServiceType", ChatServiceType] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ChatServiceAccountInfo
 */
export const ChatServiceAccountInfo = new ChatServiceAccountInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChatMessage$Type extends MessageType {
    constructor() {
        super("aware.ChatMessage", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "service_user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "service_server_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "service_channel_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "service_type", kind: "enum", T: () => ["aware.ChatServiceType", ChatServiceType] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ChatMessage
 */
export const ChatMessage = new ChatMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChatMessageSendResult$Type extends MessageType {
    constructor() {
        super("aware.ChatMessageSendResult", []);
    }
}
/**
 * @generated MessageType for protobuf message aware.ChatMessageSendResult
 */
export const ChatMessageSendResult = new ChatMessageSendResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DiscordPresence$Type extends MessageType {
    constructor() {
        super("aware.DiscordPresence", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "status", kind: "enum", T: () => ["aware.DiscordPresenceStatus", DiscordPresenceStatus] },
            { no: 9, name: "activities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DiscordActivity },
            { no: 10, name: "test_string", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.DiscordPresence
 */
export const DiscordPresence = new DiscordPresence$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DiscordActivity$Type extends MessageType {
    constructor() {
        super("aware.DiscordActivity", [
            { no: 1, name: "application_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "details", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "activity_timestamp_start", kind: "message", T: () => Timestamp },
            { no: 9, name: "activity_timestamp_end", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.DiscordActivity
 */
export const DiscordActivity = new DiscordActivity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlaceClassificationRequest$Type extends MessageType {
    constructor() {
        super("aware.PlaceClassificationRequest", [
            { no: 1, name: "place_to_classify", kind: "message", T: () => Place },
            { no: 2, name: "event_names_at_place", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.PlaceClassificationRequest
 */
export const PlaceClassificationRequest = new PlaceClassificationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlaceClassificationResult$Type extends MessageType {
    constructor() {
        super("aware.PlaceClassificationResult", [
            { no: 1, name: "place_category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "confidence", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.PlaceClassificationResult
 */
export const PlaceClassificationResult = new PlaceClassificationResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestaurantRecommendationRequest$Type extends MessageType {
    constructor() {
        super("aware.RestaurantRecommendationRequest", [
            { no: 2, name: "input_restaurants", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "number_of_recommendations", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "query_city_state_country", kind: "message", T: () => CityStateCountryInfo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.RestaurantRecommendationRequest
 */
export const RestaurantRecommendationRequest = new RestaurantRecommendationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestaurantRecommendation$Type extends MessageType {
    constructor() {
        super("aware.RestaurantRecommendation", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cuisine", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "similar_to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "place", kind: "message", T: () => Place }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.RestaurantRecommendation
 */
export const RestaurantRecommendation = new RestaurantRecommendation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestaurantRecommendationList$Type extends MessageType {
    constructor() {
        super("aware.RestaurantRecommendationList", [
            { no: 1, name: "recommendations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RestaurantRecommendation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.RestaurantRecommendationList
 */
export const RestaurantRecommendationList = new RestaurantRecommendationList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClassifyEventWithPersonRequest$Type extends MessageType {
    constructor() {
        super("aware.ClassifyEventWithPersonRequest", [
            { no: 1, name: "query_person", kind: "message", T: () => Person },
            { no: 2, name: "event", kind: "message", T: () => Event },
            { no: 3, name: "event_place", kind: "message", T: () => Place }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ClassifyEventWithPersonRequest
 */
export const ClassifyEventWithPersonRequest = new ClassifyEventWithPersonRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClassifyEventWithPersonResponse$Type extends MessageType {
    constructor() {
        super("aware.ClassifyEventWithPersonResponse", [
            { no: 1, name: "is_meeting_with_person", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "confidence", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ClassifyEventWithPersonResponse
 */
export const ClassifyEventWithPersonResponse = new ClassifyEventWithPersonResponse$Type();
/**
 * @generated ServiceType for protobuf service aware.DiscordInterfaceService
 */
export const DiscordInterfaceService = new ServiceType("aware.DiscordInterfaceService", [
    { name: "sendChatMessage", options: {}, I: ChatMessage, O: ChatMessageSendResult }
]);
/**
 * @generated ServiceType for protobuf service aware.FakeServiceComputerEvents
 */
export const FakeServiceComputerEvents = new ServiceType("aware.FakeServiceComputerEvents", [
    { name: "Bar", options: {}, I: Empty, O: Empty }
]);
/**
 * @generated ServiceType for protobuf service aware.LLMUtilService
 */
export const LLMUtilService = new ServiceType("aware.LLMUtilService", [
    { name: "classifyPlace", options: {}, I: PlaceClassificationRequest, O: PlaceClassificationResult },
    { name: "recommendRestaurants", options: {}, I: RestaurantRecommendationRequest, O: RestaurantRecommendationList },
    { name: "classifyEventWithPerson", options: {}, I: ClassifyEventWithPersonRequest, O: ClassifyEventWithPersonResponse }
]);
